export default __webpack_public_path__ + "static/assistAiIntegration-edbbd5f3d90508413da639d3c07c53c8.webp";